import axios from "axios";
import useAuthStore from './stores/auth.store'
import { jwtDecode } from 'jwt-decode';


const axiosInstance = axios.create({
    baseURL: import.meta.env.VITE_BACKEND_URL,
});

let refreshPromise;

const tokenExpiration = (store, key, token) => {
    const stored = Number(store.getItem(key));
    if (Number.isFinite(stored) && stored > 0) return stored;
    try {
        const expiration = jwtDecode(token).exp * 1000;
        if (Number.isFinite(expiration)) {
            store.setItem(key, String(expiration));
            return expiration;
        }
    } catch { /* La API rechazará un token inválido. */ }
    return 0;
};

axiosInstance.interceptors.request.use(
    async config => {
        const store = localStorage.getItem('access_token') ? localStorage : sessionStorage;
        const refreshToken = store.getItem('refresh_token');
        const accessToken = store.getItem('access_token');
        const now = Date.now();

        if (refreshToken && tokenExpiration(store, 'refresh_token_expiration', refreshToken) <= now) {
            useAuthStore().logout();
            throw new Error('La sesión expiró. Vuelve a iniciar sesión.');
        }

        if (accessToken && refreshToken && tokenExpiration(store, 'access_token_expiration', accessToken) <= now + 30000) {
            if (!refreshPromise) {
                refreshPromise = axios.post('/api/auth/refresh-token', { refreshToken }, {
                    baseURL: axiosInstance.defaults.baseURL
                }).then(response => {
                    const token = response.data?.data?.token ?? response.data?.token;
                    if (!token) throw new Error('No se pudo renovar la sesión. Vuelve a iniciar sesión.');
                    useAuthStore().refreshToken(token);
                    return token;
                }).catch(error => {
                    if (error.response?.status === 401 || error.message === 'No se pudo renovar la sesión. Vuelve a iniciar sesión.')
                        useAuthStore().logout();
                    throw error;
                }).finally(() => { refreshPromise = undefined; });
            }
            await refreshPromise;
        }

        const currentToken = store.getItem('access_token');
        if (currentToken) config.headers.Authorization = `Bearer ${currentToken}`;
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);


export default axiosInstance;
